<template>
  <div style="margin-top:20px;line-height: 40px">
    <span>
      {{ $t("lang.DateSelect.StatisticType") }}：
      <el-select v-model="DateClassValue" :placeholder="$t('lang.DateSelect.PleaseChoose')" size="mini"
        class="DateSelectP">
        <el-option v-for="item in DateClass" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </span>
    <span>
      {{ $t("lang.DateSelect.year") }}：
      <el-select v-model="Year" :placeholder="$t('lang.DateSelect.message3')" size="mini" @change="GetMonthClass"
        class="DateSelectP">
        <el-option v-for="item in YearClass" :key="item.value" :label="item.value" :value="item.value">
        </el-option>
      </el-select>
    </span>
    <span v-show="DateClassValue >= 2">
      {{ $t("lang.DateSelect.month") }}：
      <el-select v-model="Month" :placeholder="$t('lang.DateSelect.PleaseChoose')" size="mini" @change="GetDayClass"
        class="DateSelectP">
        <el-option v-for="item in MonthClass" :key="item.value" :label="item.value" :value="item.value">
        </el-option>
      </el-select>
    </span>
    <span v-show="DateClassValue >= 3">
      {{ $t("lang.DateSelect.data") }}：
      <el-select v-model="Day" :placeholder="$t('lang.DateSelect.PleaseChoose')" size="mini" class="DateSelectP">
        <el-option v-for="item in DayClass" :key="item.value" :label="item.value" :value="item.value">
        </el-option>
      </el-select>
    </span>
    <span v-show="DateClassValue >= 4">
      {{ $t("lang.DateSelect.hour") }}：
      <el-select v-model="Hour" :placeholder="$t('lang.DateSelect.PleaseChoose')" size="mini" class="DateSelectP">
        <el-option v-for="item in HourClass" :key="item.value" :label="item.value" :value="item.value">
        </el-option>
      </el-select>
    </span>
    <span>
      {{ $t("lang.DateSelect.Group1") }}：
      <el-select v-model="GroupingValue" :placeholder="$t('lang.DateSelect.PleaseChoose')" filterable
        style="margin-right: 10px" size="mini">
        <el-option v-for="item in AllGrouplist" :key="item.group_id" :label="item.group_name" :value="item.group_id">
        </el-option>
      </el-select>
    </span>
    <span>
      {{ $t("lang.DateSelect.Group2") }}：
      <el-select v-model="Grouping2Value" style="margin-right: 10px" :placeholder="$t('lang.DateSelect.PleaseChoose')"
        filterable clearable size="mini">
        <el-option v-for="item in Grouplist2" :key="item.group_id" :label="item.group_name" :value="item.group_id">
        </el-option>
      </el-select>
    </span>
    <span>
      {{ $t("lang.DateSelect.Group3") }}：
      <el-select v-model="Grouping3Value" style="margin-right: 10px" :placeholder="$t('lang.DateSelect.PleaseChoose')"
        filterable clearable size="mini">
        <el-option v-for="item in Grouplist3" :key="item.group_id" :label="item.group_name" :value="item.group_id">
        </el-option>
      </el-select>
    </span>
    <span>
      {{ $t("lang.DateSelect.Device") }}：
      <el-select v-model="DeviceDid" :placeholder="$t('lang.DateSelect.PleaseChoose')" filterable size="mini" remote
        :remote-method="remoteMethod" style="margin-right: 10px;width: 240px" :multiple="Multiple"
        :collapse-tags="Multiple" @change="DeviceSelect">
        <el-option v-for="item in DeviceList" :key="item.deviceDid" :label="item.deviceSn" :value="item.deviceDid">
          <span style="margin-right: 30px">{{ item.deviceSn }}</span>
        </el-option>
      </el-select>
    </span>
    <el-button type="primary" size="mini" @click="StatisticType">
      {{ $t("lang.DateSelect.Statistical") }}
    </el-button>
  </div>
</template>

<script>
import {
  getGroupList,
  querySNs,
  GroupDevices,
  getAddLevel3Group,
} from "../../../api/graphs";
import { mapGetters } from "vuex";
export default {
  props: {
    Multiple: {
      //默认值
      default: false,
    },
  },
  data() {
    return {
      //日期分类选项
      DateClass: [
        {
          label: this.$t("lang.DateSelect.year"),
          value: 1,
        },
        {
          label: this.$t("lang.DateSelect.month"),
          value: 2,
        },
        {
          label: this.$t("lang.DateSelect.data"),
          value: 3,
        },
        {
          label: this.$t("lang.DateSelect.hour"),
          value: 4,
        },
      ],
      DateClassValue: 1,
      YearClass: [],
      Year: new Date().getFullYear(),
      MonthClass: [],
      Month: "",
      DayClass: [],
      Day: "",
      //24小时分类
      HourClass: [
        { value: "00" },
        { value: "01" },
        { value: "02" },
        { value: "03" },
        { value: "04" },
        { value: "05" },
        { value: "06" },
        { value: "07" },
        { value: "08" },
        { value: "09" },
        { value: "10" },
        { value: "11" },
        { value: "12" },
        { value: "13" },
        { value: "14" },
        { value: "15" },
        { value: "16" },
        { value: "17" },
        { value: "18" },
        { value: "19" },
        { value: "20" },
        { value: "21" },
        { value: "22" },
        { value: "23" },
      ],
      Hour: "",
      //一级分组选中值
      GroupingValue: "",
      //二级分组列表
      Grouplist2: [],
      Grouplist3: [],
      //二级分组选中值
      Grouping2Value: "",
      Grouping3Value: "",
      //设备列表
      DeviceList: [],
      DeviceDid: "",
      //一级分组
      AllGrouplist: [],
      //远程搜索内容
      RemoteValue: "",
      //分组下的设备分页
      GroupDeviceListOffset: 1,
      GroupDeviceListLimit: 10,
      //远程搜索设备分页
      RemoteDeviceListOffset: 1,
      RemoteDeviceListLimit: 10,
      selectGid: undefined
    };
  },
  computed: {
    ...mapGetters(["defaultGroupId"]),
  },
  watch: {
    GroupingValue: {
      immediate: true,
      handler() {
        this.Grouplist2 = [];
        this.Grouplist3 = [];
        this.Grouping2Value = "";
        this.Grouping3Value = "";
        this.DeviceDid = [];
        //获取二级分组和获取一级分组下的设备列表
        if (this.GroupingValue) {
          // 获取分组
          getAddLevel3Group(this.GroupingValue).then((res) => {
            this.Grouplist2 = res.data.queryResult;
          });
          // 获取一级分组下的设备
          this.GetGroupDeviceList(this.GroupingValue);
        }
      },
    },
    Grouping2Value: {
      immediate: true,
      handler() {
        this.Grouplist3 = [];
        this.Grouping3Value = "";
        this.DeviceDid = [];
        //获取三级分组和获取二级分组下的设备列表
        if (this.Grouping2Value) {
          // 获取分组
          getAddLevel3Group(this.Grouping2Value).then((res) => {
            this.Grouplist3 = res.data.queryResult;
          });
          // 获取二级分组下的设备
          this.GetGroupDeviceList(this.Grouping2Value);
        }
      },
    },
    Grouping3Value: {
      immediate: true,
      handler() {
        this.DeviceDid = [];
        //获取三级分组和获取二级分组下的设备列表
        if (this.Grouping3Value) {
          // 获取二级分组下的设备
          this.GetGroupDeviceList(this.Grouping3Value);
        }
      },
    },
  },
  mounted() {
    //获取默认分组
    this.GroupingValue = parseInt(this.defaultGroupId) || "";
    // //获取分组与分组下的设备
    this.getGroupList();
    //获取当前年份
    this.GetYearClass();
    //获取当前月份
    this.GetMonthClass();
    //获取当前日期
    this.GetDayClass();
  },
  methods: {
    remoteMethod(query) {
      console.log(query,this.selectGid);
      if (query != '' && this.selectGid) {
        this.GetGroupDeviceList(this.selectGid, query)
      } else {
        this.GetGroupDeviceList(this.selectGid)
      }
    },
    //获取分组下的设备
    GetGroupDeviceList(val, query) {
      this.selectGid = val;
      // 先清空数据
      this.DeviceList = [];
      GroupDevices(val, 1, 1000, 1, query).then((res) => {
        let data = res.data.data.list
        let deviceList = [];
        data.forEach((element) => {
          let item = {
            deviceSn: element.deviceName
              ? element.deviceSn + " " + "(" + element.deviceName + ")"
              : element.deviceSn + " " + "(N/A)",
            deviceDid: element.deviceDid,
          };
          deviceList.push(item);
        });
        //如果父组件传入可多选，并且当前设备数量大于0，添加全选
        if (deviceList.length > 0 && this.Multiple) {
          //判断当前下拉列表中是否存在多选
          if (
            deviceList.find((ele) => {
              return ele.deviceSn === this.$t("lang.DateSelect.luaall_c");
            })
          ) {
            // 选择了全部
            return;
          } else {
            //不存在给它添加上
            deviceList.unshift({
              deviceDid: this.$t("lang.DateSelect.luaall_c"),
              deviceSn: this.$t("lang.DateSelect.luaall_c"),
            });
          }
        }
        this.DeviceList = deviceList;
      });
    },
    //初始化获取一级分组
    getGroupList() {
      getAddLevel3Group(0).then((res) => {
        this.AllGrouplist = res.data.queryResult;
      });
    },
    //获取年份
    GetYearClass() {
      //清空年份列表
      this.YearClass = [];
      //获取年份
      let date = new Date();
      let Year = date.getFullYear();
      //年份大于2017
      if (Year > 2017) {
        for (let i = 0; Year - i >= 2017; i++) {
          this.YearClass.push({ value: Year - i });
        }
      } else {
        for (let i = 0; i < 12; i++) {
          this.YearClass.push({ value: 12 - i });
        }
      }
    },
    //获取月份
    GetMonthClass() {
      //清空月份列表
      this.MonthClass = [];
      let date = new Date();
      //获取年份判断月份获取月份
      let Year = date.getFullYear();
      let Month = date.getMonth() + 1;
      if (this.Year === Year) {
        for (let i = 0; i < Month; i++) {
          let m = Month - i;
          if (Month - i < 10) {
            m = "0" + (Month - i);
          } else {
            m = String(Month - i);
          }
          this.MonthClass.push({ value: m });
        }
      } else {
        for (let i = 0; i < 12; i++) {
          let m = 12 - i;
          if (12 - i < 10) {
            m = "0" + (12 - i);
          } else {
            m = String(12 - i);
          }
          this.MonthClass.push({ value: m });
        }
      }
    },
    //获取当月的天数
    GetDayClass() {
      this.DayClass = [];
      //通过年月获取日
      var d = new Date(this.Year, this.Month, 0);
      let days = d.getDate();
      for (let i = 0; i < days; i++) {
        let dd = days - i;
        if (days - i < 10) {
          dd = "0" + (days - i);
        } else {
          dd = String(days - i);
        }
        this.DayClass.push({ value: dd });
      }
    },
    //设备下拉框事件
    DeviceSelect(prop) {
      //判断当前下拉框是否允许多选，并且判断当前选中项是否存在全选
      if (
        this.Multiple &&
        prop.find((ele) => {
          return ele === this.$t("lang.DateSelect.luaall_c");
        }) === this.$t("lang.DateSelect.luaall_c")
      ) {
        this.DeviceDid = [this.$t("lang.DateSelect.luaall_c")];
      }
    },
    //统计查询
    StatisticType() {
      let gid = "";
      if (!this.GroupingValue) {
        this.$message({
          showClose: true,
          message: this.$t("lang.DateSelect.message1"),
          type: "warning",
        });
        return;
      }
      if (!this.DeviceDid) {
        this.$message({
          showClose: true,
          message: this.$t("lang.DateSelect.message2"),
          type: "warning",
        });
        return;
      }
      if (this.Multiple && this.DeviceDid.length < 1) {
        this.$message({
          showClose: true,
          message: this.$t("lang.DateSelect.message2"),
          type: "warning",
        });
        return;
      }
      //传给父组件的时候删除全部
      if (
        this.Multiple &&
        this.DeviceDid.find((ele) => {
          return ele === this.$t("lang.DateSelect.luaall_c");
        }) === this.$t("lang.DateSelect.luaall_c")
      ) {
        gid =
          this.Grouping2Value != "" ? this.Grouping2Value : this.GroupingValue;
        this.DeviceDid.splice(this.$t("lang.DateSelect.luaall_c"), 1);
        //异步添加
        this.$nextTick(() => {
          this.DeviceDid.unshift(this.$t("lang.DateSelect.luaall_c"));
        });
      }
      //触发事件传给父组件
      //按照选中类型给父组件传值
      switch (this.DateClassValue) {
        case 1: {
          //未选择年份弹出
          if (!this.Year) {
            this.$message({
              showClose: true,
              message: this.$t("lang.DateSelect.message3"),
              type: "warning",
            });
            return;
          }
          //选中年
          this.$emit("StatisticType", {
            year: this.Year,
            dids:
              typeof this.DeviceDid === "number"
                ? [this.DeviceDid]
                : [...this.DeviceDid],
            DateClassValue: this.DateClassValue,
            gid: gid,
          });
          return;
        }
        case 2: {
          //未选择月份弹出
          if (!this.Month) {
            this.$message({
              showClose: true,
              message: this.$t("lang.DateSelect.message4"),
              type: "warning",
            });
            return;
          }
          //选中日
          //选中日传入日期列表(ps:这里我获取到了所有的日期)
          this.$emit(
            "StatisticType",
            {
              year: this.Year,
              month: this.Month,
              dids:
                typeof this.DeviceDid === "number"
                  ? [this.DeviceDid]
                  : [...this.DeviceDid],
              DateClassValue: this.DateClassValue,
              gid: gid,
            },
            this.DayClass
          );
          return;
        }
        case 3: {
          //未选择日期弹出
          if (!this.Day) {
            this.$message({
              showClose: true,
              message: this.$t("lang.DateSelect.message5"),
              type: "warning",
            });
            return;
          }
          //选中小时
          this.$emit("StatisticType", {
            year: this.Year,
            month: this.Month,
            day: this.Day,
            dids:
              typeof this.DeviceDid === "number"
                ? [this.DeviceDid]
                : [...this.DeviceDid],
            DateClassValue: this.DateClassValue,
            gid: gid,
          });
          return;
        }
        case 4: {
          //未选择小时弹出
          if (!this.Hour) {
            this.$message({
              showClose: true,
              message: this.$t("lang.DateSelect.message6"),
              type: "warning",
            });
            return;
          }
          //选中分钟
          this.$emit("StatisticType", {
            year: this.Year,
            month: this.Month,
            day: this.Day,
            clock: this.Hour,
            dids:
              typeof this.DeviceDid === "number"
                ? [this.DeviceDid]
                : [...this.DeviceDid],
            DateClassValue: this.DateClassValue,
            gid: gid,
          });
          return;
        }
      }
    },
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      },
    },
  },
  beforeDestroy() {
    this.DeviceList = null;
  },
};
</script>

<style scoped>
.DateSelectP {
  width: 80px;
  margin-right: 10px;
}
</style>
